__turbopack_context__.v({
  "card-container": "more-courses-by-instructors-module-scss-module__ccmpka__card-container",
  "margin-top-xs": "more-courses-by-instructors-module-scss-module__ccmpka__margin-top-xs",
});
